import * as product from '../constants/product-types'

export const cardOrder = {
    [product.TUDO]: 1,
    [product.POD]: 2,
    [product.FEED]: 3,
    [product.MEAL]: 4,
    [product.CHRISTMAS]: 5,
    [product.CULTURE]: 6
}
